import template from "./spray_start_spray.html";
import en from "./en.json";
import es from "./es.json";
import _ from "lodash";
import moment from "moment";
import {
    sprayApplicationRecordState,
    spraySuccessState,
} from "../../../../base.routes";

class SprayStartSprayController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        let ctrl = this;
        ctrl.record = ctrl.applicationRecord;
        ctrl.showSpinner = false;
        ctrl.errors = {};
        ctrl.showMap = ctrl.fields.length > 0;

        if (ctrl.record.end_date) {
            ctrl.$state.go(spraySuccessState, {
                application_record_sid: ctrl.record.sid,
            });
            return;
        }

        if (ctrl.record.start_date) {
            ctrl.$state.go(sprayApplicationRecordState, {
                application_record_sid: ctrl.record.sid,
            });
        }
    }

    startSpray() {
        let ctrl = this;
        ctrl.showSpinner = true;
        ctrl.errors = {};

        ctrl.record.applicator = ctrl.myGrowerMembership.sid;
        ctrl.record.start_date = moment().toISOString();

        ctrl.record
            .save()
            .then(function (record) {
                ctrl.$state.go(sprayApplicationRecordState, {
                    application_record_sid: record.sid,
                });
            })
            .catch(function (reason) {
                ctrl.errors = (reason && reason.data) || {};
                ctrl.showSpinner = false;
            });
    }
}

export default {
    name: "sprayStartSpray",
    template: template,
    controller: SprayStartSprayController,
    bindings: {
        applicationRecord: "<",
        fields: "<",
        pesticideProducts: "<",
        myGrowerMembership: "<",
    },
    translations: { en, es },
};
